import limitHeightAnalysis from './limitHeightAnalysis.vue';
export default limitHeightAnalysis;
